import React, { useContext } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { AuthContext } from '../contexts/AuthContext';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import { motion, AnimatePresence } from 'framer-motion';

function ProtectedRoute() {
    const auth = useContext(AuthContext);
    const location = useLocation();

    if (!auth) {
        // This case should ideally be handled by ensuring AuthProvider wraps the app
        console.error("ProtectedRoute used outside of AuthProvider");
        return <div>Error: Auth context not available</div>;
    }

    if (auth.isLoading) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
                <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
                    <CircularProgress />
                </motion.div>
            </Box>
        );
    }

    if (!auth.isAuthenticated) {
        // Redirect them to the /login page, but save the current location they were
        // trying to go to. This allows us to send them along to that page after login,
        // which is a nicer user experience than dropping them off on the home page.
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    return (
        <AnimatePresence mode="wait">
            <motion.div
                key="protected"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
            >
                <Outlet />
            </motion.div>
        </AnimatePresence>
    );
}

export default ProtectedRoute; 